const UnderDevelopmentComponent = () => (
  <div className="p-4 flex items-center justify-center h-full text-3xl">
    🚧 Under Development.. Please check back again soon 🚀
  </div>
);

export default UnderDevelopmentComponent;
